module.exports = __webpack_public_path__ + "img/cross.dc65d051.svg";